<template>
  <view class="index order-details">
    <!-- <van-nav-bar title="订单信息" left-arrow @click-left="onBack" /> -->
    <van-notice-bar color="#1989fa" background="#ecf9ff" left-icon="clock-o" v-if="isExpiredRemind()">
      剩{{expiredTime}}将自动关闭，请尽快支付。
    </van-notice-bar>
    <div class="order">
       <div class="order-info">{{order.restaurantName}}  {{order.restaurantCookingStyle}}  ¥{{order.restaurantPricerPerPerson}}/人 </div>
       <div class="order-row ho-center">
         <!-- <div class="order-image" style="background-image: {{order.productImageUrl}};"></div> -->
          <van-image class="order-image" :src="order.productImageUrl" />
          <div class="order-detail ho-center">
            <div class="left-side">
              <div class="order-name">{{order.productName}}</div>
              <div class="order-price ho-center">
                <span class="price">¥{{ order.productPrice }}</span>
                <span class="ori-price">原价:¥{{order.productOriginPrice}}</span>
              </div>
              <div v-if="!payment" class="order-date">下单时间：<span>{{getTime(order.createTime)}}</span></div>
            </div>
            <div class="right-side">
              <div v-if="!payment" class="order-amount">X1</div>
            </div>
          </div>
       </div>
    </div>
    <div class="cell-line" v-if="payment"><span>数量</span><van-stepper v-model="order.quantity" step="1" min="1" max="1"  /></div>
    <div class="cell-line" v-if="payment"><span>总价</span><span>¥{{order.amount}}</span></div>
    <div class="cell-line" v-if="!payment"><span>优惠减免</span><span>-¥{{order.discount}}</span></div>
    <div class="cell-line" v-if="!payment"><span>共 1 件商品</span><span>¥{{order.amount}}</span></div>

    <div class="bottom-confirm">
      <div class="confirm-area">
        <van-button block type="primary" @click="onPaymentOrder" v-if="payment">¥{{order.amount}} 立即支付</van-button>
        <div class="button-row" v-if="!payment">
            <van-button plain type="primary" @click="onShowCancelOrder">取消订单</van-button>
            <van-button type="primary" @click="onPaymentOrder">立即支付</van-button>
        </div>
      </div>
    </div>

    <van-popup v-model:show="cancelOrderShow" round position="bottom" @click="onCancelShowCancelOrder" @click-overlay="onCancelShowCancelOrder">
      <div class="cancel-card">
        <div class="cancel-info">
          是否确认取消订单
        </div>
        <div class="button-row">
          <van-button type="primary" @click="onCancelShowCancelOrder">再想想</van-button>
          <van-button plain type="primary" @click="onCancelOrder">确定</van-button>
        </div>
      </div>
    </van-popup>

  </view>
</template>

<script>
import { reactive, toRefs, onMounted} from "vue";
import { useRoute, useRouter} from "vue-router";
import { parseTime } from "../utils/index"
import { loading , clearLoading} from "../utils/loading";
import Controller from "./order-controller";
import "../css/restaurant-details.scss";
import '../css/order.scss'

export default {
  created() {
    Controller.onCreated();
  },
  setup() {
    const state = reactive({
      order: {},
      orderId: 0,
      payment: false,
      cancelOrderShow: false,
      expiredTime: null
    });
    const router = useRouter();
    const { orderId , payment } = useRoute().params;
    state.orderId = orderId;
    state.payment = payment === "paying" ? true : false;
    const getTime = t => parseTime(new Date(t), "{y}-{m}-{d} {h}:{i}");
    const onShowCancelOrder = ()=> state.cancelOrderShow = true;
    const onCancelShowCancelOrder = ()=> state.cancelOrderShow = false;
    const onCancelOrder = ()=> {
        loading()
        Controller.cancelOrder(state).then(() => {
          state.cancelOrderShow = false;
          router.push("/dish");
          clearLoading();
        } , clearLoading)
    }
    const onPaymentOrder = () =>  {
        loading()
        Controller.paymentOrder(state).then(() => clearLoading() , ()=> {
            router.push("/dish")
            clearLoading();
        })
    }
    const isExpiredRemind = () => Controller.isExpiredRemind(state);
    onMounted(() =>  {
      loading()
      Controller.onMounted(state , orderId)
        .then(clearLoading, clearLoading);
    });
    return {
      ...toRefs(state),
      onCancelOrder,
      onShowCancelOrder,
      onCancelShowCancelOrder,
      onPaymentOrder,
      getTime,
      isExpiredRemind
    }
  }
}
</script>